import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

export function createMonitoring(flowAPI: ControllerFlowAPI) {
  return {
    sentry: flowAPI.sentry,
    fedopsLogger: flowAPI.fedops,
  };
}
